import { controls } from "../controls";
import React, { Component } from 'react';

let Fixed_Deposit = "87e5be37-3150-4770-9cfb-91426aaafac2";
let Reinvestment_Deposit = "501efb9e-62cd-4226-ba7e-87d564cdfec9";


let Savings_Regular = "f38ef10a-4ea0-11e3-9221-4c72b931b19d";
let Savings_Swift = "58ec36b4-39ee-4b7b-a9c9-3d4f3042a76d";
let Savings_No_Frill = "7d2d4dcc-9133-40c4-b8d0-18ed8e1584c7";
let Current = "e55b3b1d-0e63-4aee-89a5-618cdf8227dd";
let Current_Swift = "50e4d581-d192-47ff-8ad9-db20c995da37";
let Pigmy_Deposit = "d41e2746-5b2a-11e3-ad02-4c72b931b19d";
let Recurring_Deposit = "e7575178-fd21-4d7a-ba32-987e84fb62fa";
let Call_Deposit = "75d72756-4e43-4e8d-8e6a-da63803990e3";
let Swift_Deposit = "20f71c58-ac91-4b7c-a2d3-1ea3fcc4d19f";

const tr008 = {
  label: "Transfer",
  pageLabel: "Transfer",
  starting: true,
  url: "tr008",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [

    ...controls.displayText({ tab: "filter", label: "Branch", width: "col-sm-1" }),
    ...controls.oc({ tab: "filter", defaultValue: "assigned_branch", length: 4, width: "col-sm-1", c: "Branch", placeHolder: "Branch Code", name: "Customer-branch-branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "Customer-branch-branch_display", width: "col-sm-2" }),

    // ...controls.magicDateLabel({ label: "As on Date", width: "col-sm-1" }),
    // ...controls.magicDate({ isReadOnly: true, name: "as_on_date", default: "sessiondate", width: "col-sm-2", dateType: "ontype", }),

    // ...controls.displayText({ style: { textAlign: "right" }, label: "Credit", width: "col-sm-1" }),
    ...controls.showData({ data: "total_credit", name: "total_credit", displaytype: "currency", width: "col-sm-2", style: { backgroundColor: "#e8ffff" } }),

    // ...controls.displayText({ style: { textAlign: "right" }, label: "Debit", width: "col-sm-1" }),
    ...controls.showData({ data: "total_debit", displaytype: "currency", name: "total_debit", width: "col-sm-2", style: { backgroundColor: "#f1d4d4" } }),

    ...controls.displayText({ label: "Difference", width: "col-sm-1" }),
    ...controls.showData({ style: { backgroundColor: "#82ccdd" }, displaytype: "currency", data: "final_amount", name: "final_amount", width: "col-sm-1" }),

    ...controls.displayText({ label: "Batch No", width: "col-sm-1" }),
    ...controls.showData({ data: "batch_no", name: "batch_no", width: "col-sm-1" }),

    ...controls.hr({ width: "col-sm-12" }),

    // ...controls.radio({ width: "col-sm-3", name: "cdflag", cwidth: "col-sm-4", options: [{ label: "Credit", value: "credit" }, { label: "Debit", value: "debit" }], clearChildren: [{}] }),



    // ...controls.multiButton({
    //   name: "cdflag", 
    //   options: [{ label: "Credit", value: "credit" }, { label: "Debit", value: "debit" }]


    // }),


    {
      widths: "col-sm-9",
      tab: "create",
      style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
      direction: 'vertical',
      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
      subComponents: [
        {
          widths: "col-sm-12",
          tab: "create",
          title: "Transaction Information",
          style: { paddingLeft: 0, paddingRight: 0 },
          direction: 'vertical',
          pagination: { perPage: 30, buttonSize: 'col-sm-2' },
          subComponents: [
            {
              widths: "col-sm-9",
              tab: "create",
              style: { border: 0, paddingLeft: 0, paddingRight: 0 },
              direction: 'vertical',
              pagination: { perPage: 30, buttonSize: 'col-sm-2' },
              subComponents: [
                ...controls.Multibutton({
                  name: "cdflag",
                  width: "col-sm-4",
                  Bcolor: "success",
                  style: { padding: 0 },
                  options: [
                    { label: "Credit", value: "credit", width: "col-sm-6" },
                    { label: "Debit", value: "debit", width: "col-sm-6" },
                  ]
                }),

                // ...controls.displayText({ width: "col-sm-1" }),
                ...controls.closeAc({
                  label: "Close Ac?",
                  name: "isCloseAccount",
                  // parents: [
                  //   [{
                  //     name: "cdflag",
                  //     match: "in",
                  //     value: ["debit"],
                  //   },
                  //   {
                  //     name: "product_group",
                  //     match: "in",
                  //     value: [1]
                  //   },
                  //   {
                  //     name: "product_type_guid",
                  //     match: "in",
                  //     value: [Fixed_Deposit, Reinvestment_Deposit],
                  //     reverse: true
                  //   },
                  //   {
                  //     name: "account_number_guid",
                  //     match: "exist",
                  //     show: 'blank'
                  //   },
                  //   {
                  //     name: "alreadyClosed",
                  //     match: "in",
                  //     reverse: true,
                  //     value: [true],
                  //     show: 'blank'
                  //   },
                  //   {
                  //     name: "pend_debit",
                  //     match: "in",
                  //     value: [0],
                  //     show: 'blank'

                  //   }
                  //   ],
                  //   [
                  //     {
                  //       name: "cdflag",
                  //       match: "in",
                  //       value: ["credit"],
                  //     },
                  //     {
                  //       name: "product_group",
                  //       match: "in",
                  //       value: [2]
                  //     },
                  //     {
                  //       name: "account_number_guid",
                  //       match: "exist",
                  //       show: 'blank'
                  //     },
                  //     {
                  //       name: "alreadyClosed",
                  //       match: "in",
                  //       reverse: true,
                  //       value: [true],
                  //       show: 'blank'
                  //     },
                  //     {
                  //       name: "pend_credit",
                  //       match: "in",
                  //       value: [0],
                  //       show: 'blank'
                  //     }
                  //   ]
                  // ], 
                  width: "col-sm-4"
                }),

                ...controls.displayText({
                  label: "Pay Interest",
                  width: "col-sm-2",
                  parents: [
                    {
                      name: "isCloseAccount",
                      match: "exist",
                      show: 'blank'
                    }
                  ]
                }),

                ...controls.showData({
                  data: "payable_interest", width: "col-sm-2", displaytype: "currency",
                  parents: [{
                    name: "payable_interest",
                    match: "exist",
                    show: 'blank'
                  }]
                }),

                // ...controls.displayText({
                //   label: "", width: "col-sm-4", parents: [{
                //     name: "payable_interest",
                //     match: "exist",
                //     reverse: true,
                //     show: 'blank'
                //   }]
                // }),



                // ...controls.showData({
                //   prepend:"branchname",  width: "col-sm-1",
                //   parents: [
                //     {
                //       name: ["branch_code_guid", "account_branch_guid"],
                //       match: "equal",
                //       reverse: true,
                //       show: 'blank'
                //     }
                //   ]
                // }),

                {
                  inputType: "simplemodal",
                  widths: {
                    parent: "col-sm-4",
                    children: "col-sm-12"
                  },
                  label: "ABB Transaction",
                  body: <span style={{ textAlign: "center", color: "red" }}>Charges may apply as source branch %branch_display% is different from %account_branch_guid%</span>,
                  description: "none",
                  parents: [
                    {
                      name: ["branch_guid", "account_branch_guid"],
                      match: "equal",
                      reverse: true
                    }
                  ]
                },
                {
                  inputType: "simplemodal",
                  widths: {
                    parent: "col-sm-4",
                    children: "col-sm-12"
                  },
                  label: "ABB Transaction",
                  body: <span style={{ textAlign: "center", color: "red" }}>Charges may apply</span>,
                  description: "none",
                  parents: [
                    {
                      name: ["branch_guid", "account_branch_guid"],
                      match: "equal",
                      reverse: true
                    }
                  ]
                },


                ...controls.displayText({ label: "Ac No", width: "col-sm-2" }),

                ...controls.oc({ tab: "filter", width: "col-sm-3", length: 4, c: "Account", placeHolder: "Ac No", name: "account_code", fastpath: "ms201" }),


                // ...controls.AccountNumber({
                //   forceRender: true,
                //   width: "col-sm-3",
                //   beforeLeave: ["createAcNo"],
                //   onLeave: [
                //     // "checkPAN", "checkMobile", "checkSMS", "checkaadhar", 
                //     "checkLoans", "checkAcClosed", "checkLienMarking", "checkMinBal", "checkRenewal", "checkPremature"], // {type:'check',value:'pan'},{type:'match',value:12000},
                //   clearData: ['entered_amount', 'payable_interest', 'total_explanation'],
                //   displayData: {
                //     producttype_guid: "producttype_guid", descn: "account_number_display", account_number_guid: 'account_number_guid', balance: "balance", pendingcharges: 'pending_charges', customer_number: "customer_number", interest_rate: "interest_rate", mobile: "mobile", interest_debited: "interest_debited", minbalance: "min_balance", pan: "pan", total: "total", fd_amount: "fd_amount", aadhar: "aadhar", mat_amount: "maturity_amount", account_opening_date: "account_opening_date", expdate: "expdate", closedate: "closedate", intdate: "intdate", withdrawable: "withdrawable", product_code: { field: "product_code", skip: true }, RiskCategory: "RiskCategory", custtype: "custtype", kycduedate: "kycduedate", kycdone: "kycdone", cashpaymentday: "cashpaymentday", cashreceiptday: "cashreceiptday", cashpaymentweek: "cashpaymentweek", cashreceiptweek: "cashreceiptweek", qtrreceipts: "qtrreceipts", qtrpayments: "qtrpayments", cashpaymentyear: "cashpaymentyear", account_code: "account_number", cashreceiptyear: "cashreceiptyear", openbyuser: "openbyuser", closing_charges: "entered_charges", branch_code_guid: "account_branch_guid", product_code_guid: "product_code_guid", pend_debit: "pend_debit", pend_credit: "pend_credit", branchname: "branchname", branchcode: "branchcode"
                //   },
                //   parents: [
                //     {
                //       name: "cdflag",
                //       match: "exist",
                //       show: 'readonly'
                //     }
                //   ]
                // }),
                ...controls.showData({ data: "account_display", width: "col-sm-7" }),
                // ...controls.displayText({ label: "", width: "col-sm-3" }),

                ...controls.displayText({ label: "Instru No", width: "col-sm-2" }),
                ...controls.numberOnly({ name: "inst_no", width: "col-sm-3" }),

                ...controls.magicDateLabel({ label: "Instrument Date", width: "col-sm-4", target: "inst_date" }),
                ...controls.magicDate({ dateType: "ontype", name: "inst_date", width: "col-sm-3" }),

                // ...controls.displayText({ label: "", width: "col-sm-1" }),


                ...controls.displayText({ label: "Amount", width: "col-sm-2" }),
                ...controls.numtoword({
                  convertedTo: "entered_amount_text",
                  name: "entered_amount",
                  width: "col-sm-3",
                  onRender: [
                    // calculate withdrawable - amount
                    { f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'pageData.withdrawable' }, { source: 'pageData.entered_amount', mult: { source: "pageData.cdflag", condition: { debit: -1 } } }], resultVar: 'new_balance' },
                    // set parent state, for new balance
                    { f: 'setParentState', inputs: { dest: "pageData.new_balance", source: 'allResults', field: 'new_balance' }, resultVar: "maturity_amount" },
                  ],
                  parents: [
                    {
                      name: 'amountReadOnly',
                      match: "in",
                      value: [true],
                      reverse: true
                    }
                  ]
                }),

                // ...controls.showData({
                //   data: "entered_amount",
                //   width: "col-sm-2",
                //   displaytype: "currency",
                //   onRender: [
                //     // calculate withdrawable - amount
                //     { f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'pageData.withdrawable' }, { source: "pageData.payable_interest" }, { source: 'pageData.entered_charges', mult: { source: "fixed", fixed: { mul: -1 }, field: "mul" } }, { source: 'pageData.entered_amount', mult: { source: "pageData.cdflag", condition: { debit: -1 } } }], resultVar: 'new_balance' },
                //     // set parent state, for new balance
                //     { f: 'setParentState', inputs: { dest: "pageData.new_balance", source: 'allResults', field: 'new_balance' }, resultVar: "maturity_amount" },
                //   ],
                //   parents: [
                //     {
                //       name: 'amountReadOnly',
                //       match: "in",
                //       value: [true],
                //     }
                //   ]
                // }),

                ...controls.showData({
                  data: "entered_amount_text", name: "entered_amount_text", width: "col-sm-7", style: { fontSize: 14 },
                }),

                // ...controls.displayText({ style: { textAlign: 'right' }, label: "New Balance", width: "col-sm-1" }),
                // ...controls.showData({ data: "new_balance", displaytype: "currency", width: "col-sm-2" }),


                ...controls.displayText({
                  style: { textAlign: 'right' }, label: "Charges", width: "col-sm-2", style: { color: "orange" },
                  parents: [
                    {
                      name: "isCloseAccount",
                      match: "exist",
                      // show: 'blank'
                    }
                  ]
                }),
                ...controls.numtoword({
                  convertedTo: "entered_charges_text", name: "entered_charges", width: "col-sm-3",
                  onRender: [
                    // calculate withdrawable - amount
                    { f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'pageData.balance' }, { source: "pageData.payable_interest" }, { source: 'pageData.entered_charges', mult: { source: "fixed", fixed: { mul: -1 }, field: "mul" } }], resultVar: 'new_balance' },
                    // set parent state, for new balance
                    { f: 'setParentState', inputs: { dest: "pageData.entered_amount", source: 'allResults', field: 'new_balance' }, resultVar: "maturity_amount" },
                  ],
                  parents: [
                    {
                      name: "isCloseAccount",
                      match: "exist",
                      // show: 'blank'
                    }
                  ]
                }),
                ...controls.showData({
                  data: "entered_charges_text", width: "col-sm-7", style: { fontSize: 14 }, parents: [
                    {
                      name: "isCloseAccount",
                      match: "exist",
                      // show: 'blank'
                    }
                  ]
                }),

                ...controls.displayText({ label: "Particulars", width: "col-sm-2" }),
                ...controls.text({ name: "particulars", width: "col-sm-6" }),


                ...controls.button({
                  label: "Add",
                  onclick: {
                    action: [
                      { act: "unlockAccountNumber", sendToServer: { dataType: "unlockAcNo", sendData: ['branch_guid', 'account_number'] } },
                      { act: "appendToHTMLTable" }
                    ],
                    tableNameField: 'transaction_grid',
                    requiredField: ["product_code_display", "product_code", "account_number", "account_number_display", "cdflag", "entered_amount", "particulars", "new_balance"],
                    removeExcept: ['branch_code', 'branch_display', 'branch_guid', 'as_on_date', 'batch_no', 'total_credit', 'total_debit', 'final_amount', 'cdflag'],
                  },
                  // parents: [
                  //   {
                  //     name: "entered_amount",
                  //     match: "exist",
                  //     show: 'blank'
                  //   }
                  // ],
                  width: "col-sm-2",
                  style: { padding: 0 },
                  Bcolor: "success"
                }),

                // ...controls.button({ label: "Clear", style: { padding: 0 }, Bcolor: "danger", width: "col-sm-1" }),

                ...controls.button({
                  label: "Clear", onclick: {
                    action: [
                      { act: "unlockAccountNumber", sendToServer: { dataType: "unlockAcNo", sendData: ['branch_guid', 'account_number'] } }, { act: "clearHTMLTableForm" }
                    ],
                    tableNameField: 'transaction_grid',
                    requiredField: ["product_code_display", "product_code", "product_code_guid", "account_number", "account_number_display", "cdflag", "entered_amount", "particulars", "new_balance"],
                    removeExcept: ['branch_code', 'branch_display', 'branch_code_guid', 'as_on_date', 'batch_no', 'total_credit', 'total_debit', 'final_amount', 'cdflag'],
                  }, width: "col-sm-2",
                  style: { padding: 0 },
                }),



                ...controls.displayText({
                  label: "Mobile No", width: "col-sm-1",
                  parents: [
                    {
                      name: "account_number_guid",
                      match: "exist",
                      show: 'readonly'
                    },
                    {
                      name: "mobile",
                      match: "in",
                      value: [""],
                      show: 'readonly'
                    },

                  ],

                }),
                ...controls.mobileNumber({
                  name: "mobile", width: "col-sm-2", parents: [
                    {
                      name: "account_number_guid",
                      match: "exist",
                      show: 'blank'
                    },
                    {
                      name: "mobile",
                      match: "in",
                      value: [""],
                      show: 'blank'
                    },

                  ],
                }),
                ...controls.displayText({
                  label: "Aadhar", width: "col-sm-1",
                  parents: [
                    {
                      name: "account_number_guid",
                      match: "exist",
                      show: 'readonly'
                    },
                    {
                      name: "aadhar",
                      match: "in",
                      value: [""],
                      show: 'readonly'
                    },

                  ],

                }),
                ...controls.aadharNumber({
                  width: "col-sm-2", parents: [
                    {
                      name: "account_number_guid",
                      match: "exist",
                      show: 'blank'
                    },
                    {
                      name: "aadhar",
                      match: "in",
                      value: [""],
                      show: 'blank'
                    },

                  ],
                }),
                ...controls.displayText({
                  label: "PAN", width: "col-sm-1",
                  parents: [
                    {
                      name: "account_number_guid",
                      match: "exist",
                      show: 'readonly'
                    },
                    {
                      name: "pan",
                      match: "in",
                      value: [""],
                      show: 'readonly'
                    },

                  ],

                }),
                ...controls.panNumber({
                  width: "col-sm-2", parents: [
                    {
                      name: "account_number_guid",
                      match: "exist",
                      show: 'blank'
                    },
                    {
                      name: "pan",
                      match: "in",
                      value: [""],
                      show: 'blank'
                    },

                  ],
                }),

              ]
            },
            {
              widths: "col-sm-3",
              tab: "create",
              // title: "Signature",
              style: { border: 0, paddingLeft: 0, paddingRight: 0 },
              direction: 'vertical',
              pagination: { perPage: 30, buttonSize: 'col-sm-2' },
              subComponents: [


              ]
            }
            // ...controls.checkBox({ label: "SMS ", name: "isSMS", width: "col-sm-4" }),
          ]
        },
        {
          inputType: "table",
          tableTitle: "",
          isRequired: true,
          editable: false,
          deletable: false,
          copyable: false,
          toggledropdown: true,
          togglebutton: [{ label: 'Edit', editable: false, }, { label: 'Delete', deletable: false, }],
          tableHeaders: [
            { label: "Sr", type: "autoinc" },
            { label: "GL Code", field: "product_code" },
            { label: "GL Name", field: "product_code_display" },
            { label: "Ac Code", field: "account_number" },
            { label: "Ac Name", field: "account_number_display" },
            { label: "C/D", field: "cdflag" },
            { label: "Amount", field: "entered_amount", displaytype: 'currency' },
            { label: "Particulars", field: "particulars" },
            { label: "Balance", field: "new_balance", displaytype: 'currency' },
          ],
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          description: "Transaction Grid",
          name: "transaction_grid",
          onRender: [
            { f: 'tableCalculations', calcType: 'sum', inputs: { source: 'pageData.transaction_grid', field: 'entered_amount', filter: { cdflag: 'credit' } }, resultVar: 'totalCredit' },
            { f: 'setParentState', inputs: { dest: "pageData.total_credit", source: 'allResults', field: 'totalCredit' }, resultVar: "totalCreditT" },
            { f: 'tableCalculations', calcType: 'sum', inputs: { source: 'pageData.transaction_grid', field: 'entered_amount', filter: { cdflag: 'debit' } }, resultVar: 'totalDebit' },
            { f: 'setParentState', inputs: { dest: "pageData.total_debit", source: 'allResults', field: 'totalDebit' }, resultVar: "totalDebitT" },

            { f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'allResults', field: 'totalCredit' }, { source: 'allResults', field: 'totalDebit', mult: { source: "fixed", field: 'mult', fixed: { mult: -1 } } }], resultVar: 'total' },

            { f: 'setParentState', inputs: { dest: "pageData.final_amount", source: 'allResults', field: 'totalDebit' }, resultVar: "totalDebitT" },
          ]
        }

      ]
    },





    {
      widths: "col-sm-3",
      tab: "create",
      style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
      direction: 'vertical',
      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
      subComponents: [


        {
          widths: "col-sm-12",
          tab: "create",
          title: "Alerts",
          style: { paddingLeft: 0, marginTop: -5, paddingRight: 0 },
          direction: 'vertical',
          pagination: { perPage: 30, buttonSize: 'col-sm-2' },
          subComponents: [
            {
              widths: "col-sm-12",
              style: {
                maxHeight: 400, border: 0, overflow: "scroll", padding: 0, marginBottom: 0
              },
              subComponents: [
                ...controls.displayText({ style: { color: "#b8e994" }, label: "This is an ABB TXN.", width: "col-sm-12" }),
              ]
            }
          ]
        },

        {
          widths: "col-sm-12",
          tab: "create",
          title: "Account Information",
          style: { paddingLeft: 0, paddingRight: 0 },
          direction: 'vertical',
          pagination: { perPage: 30, buttonSize: 'col-sm-2' },
          subComponents: [
            {
              widths: "col-sm-12",
              style: {
                maxHeight: 350, border: 0, overflow: "scroll", padding: 0, marginBottom: 0
              },
              subComponents: [
                ...controls.displayText({ style: { textAlign: 'right' }, label: "Balance", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", data: "balance", name: "balance", width: "col-sm-7", style: { backgroundColor: "#b8e994" } }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Shadow Amt", width: "col-sm-5" }),
                ...controls.showData({ displaytype: 'currency', data: "withdrawable", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Charges", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", data: "pending_charges", name: "pending_charges", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Cust No", width: "col-sm-5" }),
                ...controls.showData({ data: "customer_number", name: "customer_number", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Interest Rate", width: "col-sm-5" }),
                ...controls.showData({ data: "interest_rate", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Prin-Interest", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", data: "principalized_interest", name: "principalized_interest", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Mobile", width: "col-sm-5" }),
                ...controls.showData({ data: "mobile", name: "mobile", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Min Balance", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", name: "min_balance", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "PAN", width: "col-sm-5" }),
                ...controls.showData({ data: "pan", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Interest", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", data: "interest_debited", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "FD Amount", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", data: "fd_amount", name: "fd_amount", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "aadhar", width: "col-sm-5" }),
                ...controls.showData({ data: "aadhar", name: "aadhar", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Maturity amt", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", data: "maturity_amount", name: "maturity_amount", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Total", width: "col-sm-5" }),
                ...controls.showData({ style: { backgroundColor: "#b8e994" }, displaytype: "currency", more: "total_explanation", data: "total", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Opening Date", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "date", data: "account_opening_date", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Exp Date", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "date", data: "expdate", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Close Date", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "date", data: "closedate", name: "closedate", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Interest Date", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "date", data: "intdate", name: "intdate", width: "col-sm-7" }),


                ...controls.displayText({ style: { textAlign: 'right' }, label: "Customer Type", width: "col-sm-5" }),
                ...controls.showData({ data: "custtype", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Risk Category", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "decode", params: { decode: 'riskcat' }, data: "RiskCategory", name: "RiskCategory", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "KYC Due Date", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "date", data: "kycduedate", name: "kycduedate", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "KYC Done", width: "col-sm-5" }),
                ...controls.showData({ data: "kycdone", displaytype: "yesno", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Pay Day", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", data: "cashpaymentday", name: "cashpaymentday", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Rec Day", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", name: "cashreceiptday", data: "cashreceiptday", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Pay Week", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", data: "cashpaymentweek", name: "cashpaymentweek", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Rec Week", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", data: "cashreceiptweek", name: "cashreceiptweek", width: "col-sm-7" }),


                ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Rec Qtr", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", data: "qtrreceipts", name: "qtrreceipts", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Pay Qtr", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", data: "qtrpayments", name: "qtrpayments", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", data: "Cash Pay Year", name: "Cash Pay Year", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Cash Rec Year", width: "col-sm-5" }),
                ...controls.showData({ displaytype: "currency", data: "cashreceiptyear", name: "cashreceiptyear", width: "col-sm-7" }),

                ...controls.displayText({ style: { textAlign: 'right' }, label: "Open By", width: "col-sm-5" }),
                ...controls.showData({ data: "openbyuser", name: "openbyuser", width: "col-sm-7" }),
                // ]
              ]
            },
          ]
        },
        {
          widths: "col-sm-12",
          tab: "create",
          title: "Actions",
          style: { paddingLeft: 0, paddingRight: 0 },
          direction: 'vertical',
          pagination: { perPage: 30, buttonSize: 'col-sm-2' },
          subComponents: [
            {
              widths: "col-sm-12",
              style: {
                maxHeight: 400, border: 0, overflow: "scroll", padding: 0, marginBottom: 0
              },
              subComponents: [
                {
                  inputType: "button",
                  tab: "create",
                  widths: {
                    parent: "col-sm-6",
                    children: "col-sm-12"
                  },
                  placeHolder: "",
                  label: "Create FD",
                  Bcolor: "info",
                  size: "sm",
                  style: { padding: 0 },
                  parentStyle: { paddingRight: 5 },
                  name: "Renew_fd",
                  onclick: {
                    action: "handleAppendmodal",
                    loadinto: "AllData",
                  },
                  formmodal: {
                    inputType: "fastpathContainer",
                    pagename: "termdeposit2",
                  },
                  description: "Renew FD"
                },
                {
                  inputType: "button",
                  tab: "create",
                  widths: {
                    parent: "col-sm-6",
                    children: "col-sm-12"
                  },
                  placeHolder: "",
                  label: "Close Ac",
                  Bcolor: "info",
                  size: "sm",
                  style: { padding: 0 },
                  parentStyle: { paddingRight: 5 },
                  name: "Renew_fd",
                  onclick: {
                    action: "handleAppendmodal",
                    loadinto: "AllData",
                  },

                  formmodal: {
                    inputType: "fastpathContainer",
                    pagename: "termdeposit2",
                  },
                  description: "Renew FD"
                },

                {
                  inputType: "button",
                  tab: "create",
                  widths: {
                    parent: "col-sm-6",
                    children: "col-sm-12"
                  },
                  placeHolder: "",
                  label: "Statement",
                  Bcolor: "info",
                  size: "sm",
                  style: { padding: 0 },
                  parentStyle: { paddingRight: 5 },
                  name: "Renew_fd",
                  onclick: {
                    action: "handleAppendmodal",
                    loadinto: "AllData",
                  },

                  formmodal: {
                    inputType: "fastpathContainer",
                    pagename: "termdeposit2",
                  },
                  description: "Renew FD"
                },
                {
                  inputType: "button",
                  tab: "create",
                  widths: {
                    parent: "col-sm-6",
                    children: "col-sm-12"
                  },
                  placeHolder: "",
                  label: "Product",
                  Bcolor: "info",
                  size: "sm",
                  style: { padding: 0 },
                  parentStyle: { paddingRight: 5 },
                  name: "Renew_fd",
                  onclick: {
                    action: "handleAppendmodal",
                    loadinto: "AllData",
                  },

                  formmodal: {
                    inputType: "fastpathContainer",
                    pagename: "termdeposit2",
                  },
                  description: "Renew FD"
                },

                // {
                //   inputType: "button",
                //   tab: "create",
                //   widths: {
                //     parent: "col-sm-6",
                //     children: "col-sm-12"
                //   },
                //   placeHolder: "",
                //   label: "Close Ac",
                //   Bcolor: "info",
                //   size: "sm",
                //   style: { padding: 0 },
                //   name: "Renew_fd",
                //   onclick: {
                //     action: "handleAppendmodal",
                //     loadinto: "AllData",
                //   },

                //   formmodal: {
                //     inputType: "fastpathContainer",
                //     pagename: "termdeposit2",
                //   },
                //   description: "Renew FD"
                // },
              ]
            }
          ]
        },
      ]
    },




  ]
}

export default tr008;